/**
 * Spinner — indeterminate loading indicator.
 *
 * Props:
 *   size?   'md' | 'lg'   (default 'md')
 *   label?  string        — optional caption under the spinner
 *   inline? bool          — render just the disc (no centered wrapper)
 */
export default function Spinner({ size = 'md', label, inline = false }) {
  const disc = <div className={`spinner ${size === 'lg' ? 'spinner--lg' : ''}`} />;
  if (inline) return disc;
  return (
    <div className="spinner-wrap">
      {disc}
      {label ? <div>{label}</div> : null}
    </div>
  );
}
